import React from "react";
import styles from "../../createEvent.module.css";
import { CustomSelect } from "../../../../Components/CustomSelect/CustomSelect";
export const ParticipantRegistrationDetail = ({
  selectedParticipantForm,
  participantForm,
  handleChangeAudienceDropdown,
  setActiveRegistrationBtn,
  setParticipantRegistrationFieldModal,
  selectedParticipantFormDetails,
  setSelectedParticipantFormDetails,
}) => {
  const handleUpdate = (key, index) => {
    const list = [...selectedParticipantFormDetails];
    list[index][key] = list[index][key] == 0 ? 1 : 0;
    setSelectedParticipantFormDetails(list);
  };

  return (
    <div className={styles.mainDiv}>
      <div className={styles.titleDiv}>
        <p>Add a Form</p>
      </div>
      <div className={styles.displayFlexDiv2}>
        <div className={styles.selectFormDiv}>
          <label className={styles.labelFont}>Select Form</label>
          <span className={styles.star}>*</span>
          <br />
          <div style={{ marginTop: "12px" }}>
            <CustomSelect
              options={participantForm}
              value={selectedParticipantForm}
              name="eventType"
              handleOnChangeDropdown={handleChangeAudienceDropdown}
              padding={"4px"}
              border={"none"}
              height={"150px"}
            />
          </div>
        </div>
        <div>
          <div
            className={styles.addBtnSecondry}
            onClick={() => {
              setActiveRegistrationBtn("addForm");
              setParticipantRegistrationFieldModal(true);
            }}
          >
            + Add new form
          </div>
        </div>
      </div>
      <div>
        <div className={styles.selectedAudienceFormDiv}>
          <p className={styles.selectedAudienceLabel}>
            {selectedParticipantForm?.label}
          </p>
          {Object.keys(selectedParticipantForm).length > 0 && (
            <div
              className={styles.addBtnSecondry}
              style={{ marginTop: "0px" }}
              onClick={() => {
                setActiveRegistrationBtn("addField");
                setParticipantRegistrationFieldModal(true);
              }}
            >
              + Add new field
            </div>
          )}
        </div>
      </div>
      <div className={styles.displayFlexDiv3}>
        {selectedParticipantFormDetails?.map((item, index) => {
          return item?.isDelete != 1 ? (
            <div key={index}>
              <div className={styles.detailItem}>
                <p>{item?.label}</p>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    onClick={() => {
                      handleUpdate("isVisible", index);
                    }}
                    className={styles.formIcon}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/${
                        process.env.REACT_APP_IMAGES
                      }${
                        item?.isVisible
                          ? "/hideIconActive.svg"
                          : "/hideIcon.svg"
                      }`}
                      alt="hide"
                    />
                  </div>
                  <div
                    onClick={() => {
                      handleUpdate("isDelete", index);
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_IMAGES}/deleteLogo.svg`}
                      alt="Delete"
                    />
                  </div>
                </div>
              </div>
              <p className={styles.mandatoryDiv}>
                Mandatory: {item?.isMandatory ? "Yes" : "No"}
              </p>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
};
